export default __webpack_public_path__ + "static/media/P204 zu P203.8e94a992.mp3";